import { ActionIcon, Group, Text, useMantineColorScheme } from "@mantine/core"
import { version } from "@/utils/env"
import { icons, Logo } from ".."
import { BaseLayout } from "./BaseLayout"
import { LanguageButton } from "./navigation"

export function SimpleLayout({ children }) {
  const { colorScheme, toggleColorScheme } = useMantineColorScheme()
  return (
    <BaseLayout>
      <Group wrap="nowrap" justify="space-between" mx="md" align="center" h={42}>
        <LanguageButton />
        <Group wrap="nowrap" gap={4}>
          <Logo />
          <Text size="xs" c="dimmed" fw={500} opacity={0.4} mt={-4}>
            {version}
          </Text>
        </Group>
        <ActionIcon variant="transparent" color="gray" onClick={() => toggleColorScheme()}>
          {colorScheme === "dark" ? <icons.Dark /> : <icons.Light />}
        </ActionIcon>
      </Group>
      {children}
    </BaseLayout>
  )
}
